import { Component, computed, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { Item } from 'src/app/models';
import { HireItem } from 'src/app/models/hire-item';
import { Product } from 'src/app/models/product';
import { ItemDialogComponent } from 'src/app/shared/dialogs/item-dialog/item-dialog.component';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { VirtualProductLabelComponent } from 'src/app/shared/virtual-product-label/virtual-product-label.component';

@Component({
  selector: 'app-product-name-cell',
  template: `
    <div class="flex flex-row items-center space-x-2">
      @if (showQuantity()) {
        <span>{{ hireItem().quantity }} x</span>
      }
      <a
        matTooltip="View Product"
        matTooltip-position="left"
        tooltipHideDelay="0"
        [routerLink]="['/product/', product().id, { type: 'hire' }]"
        >{{ product().name }}</a
      >
      @if (isVirtualProduct()) {
        <app-virtual-product-label />
      } @else {
        <span>
          @if (hireItem().hireable_type === 'item' && item()) {
            (<a
              (click)="openItemDialog(item())"
              testId="open-item-dialog-{{ hireItem().id }}"
              matTooltip="View Item"
              >{{ item().code }}</a
            >)
          }
        </span>
      }
    </div>
    @if (item() && item().notes) {
      <p>
        <small><strong>Item details:</strong> {{ item().notes }}</small>
      </p>
    }
  `,
  standalone: true,
  imports: [
    MatTooltipModule,
    RouterLink,
    VirtualProductLabelComponent,
    TestIdDirective
  ],
  styles: []
})
export class ProductNameCellComponent {
  hireItem = input.required<HireItem>();

  isVirtualProduct = computed(
    () => this.hireItem().hireable_type === 'product'
  );
  product = computed<Product>(() =>
    this.isVirtualProduct()
      ? (this.hireItem().hireable as Product)
      : (this.hireItem().hireable as Item).product
  );
  item = computed(() =>
    this.isVirtualProduct() ? null : (this.hireItem().hireable as Item)
  );
  showQuantity = input(false);

  constructor(private dialog: MatDialog) {}

  openItemDialog(item: any): void {
    this.dialog.open(ItemDialogComponent, {
      maxWidth: '90vw',
      data: { item }
    });
  }
}
